module.exports = __webpack_public_path__ + "static/instagram-5ed0e2f84c1e57123d1f805d2ae3b1ec.png";